module.exports = __webpack_public_path__ + "img/awareness-video.ffed3fb7.svg";